export enum ReportCollectionsWorkspaceCapabilityAccessOperation {
    create = "da41c21d-5002-4e14-94c1-14e26d955305",
    read = "67c6c159-9021-4f57-8466-8dcccf3bb908",
    update = "2712a1db-5d46-4f55-b602-f8e778fb7cf2",
    delete = "a8f5ed7b-2f4b-44eb-81e8-f930fbadb818",
}
